export default __webpack_public_path__ + "assets/img/avatar-02.6168ca8ac5a4d2945890dda9322a50d2.jpg";